import { ShareSheetEntityKind } from "@/components/modal/share-sheet/types";
import {
  MDSButton,
  MDSButtonVariant,
  MDSDialog,
  MDSDialogHeaderContent,
  MDSDialogSlotName,
  MDSModal,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import styled from "@emotion/styled";

interface ShareSheetInviteToMemModalProps {
  email: string;
  entityKind?: ShareSheetEntityKind;
  isOpen: boolean;
  isSendingInvite: boolean;
  onCancel: () => void;
  onSendInvite: () => void;
}

const entityKindCopy: Record<ShareSheetEntityKind, string> = {
  [ShareSheetEntityKind.Note]: "note",
  [ShareSheetEntityKind.Collection]: "collection",
  [ShareSheetEntityKind.Template]: "template",
};

export const ShareSheetInviteToMemModal = ({
  email,
  entityKind,
  isOpen,
  isSendingInvite,
  onCancel,
  onSendInvite,
}: ShareSheetInviteToMemModalProps) => {
  const entityCopy = entityKind ? entityKindCopy[entityKind] : "note";
  return (
    <MDSModal isOpen={isOpen} handleClose={onCancel}>
      <MDSDialog isOpen={isOpen} handleClose={onCancel}>
        <MDSDialogHeaderContent slot={MDSDialogSlotName.Header}>
          <MDSText variant={MDSTextVariant.HeaderL}>Send invite to Mem</MDSText>
        </MDSDialogHeaderContent>
        <ModalBody slot={MDSDialogSlotName.Content}>
          <DescriptionText variant={MDSTextVariant.TextS}>
            <EmailHighlight>{email}</EmailHighlight> will get an email invitation to join Mem and
            collaborate on this {entityCopy}. Invites expire after 7 days and cannot be revoked.
          </DescriptionText>
        </ModalBody>
        <ModalFooter slot={MDSDialogSlotName.Footer}>
          <MDSButton
            variant={MDSButtonVariant.Default}
            onClick={onCancel}
            isDisabled={isSendingInvite}
          >
            Cancel
          </MDSButton>
          <MDSButton
            variant={MDSButtonVariant.Emphasis}
            onClick={onSendInvite}
            isLoading={isSendingInvite}
          >
            Send invite
          </MDSButton>
        </ModalFooter>
      </MDSDialog>
    </MDSModal>
  );
};

const ModalBody = styled.div(({ theme }) => ({
  padding: theme.spacing["2"],
  paddingTop: theme.spacing["3"],
  paddingBottom: theme.spacing["3"],
}));

const ModalFooter = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing["2"],
  width: "100%",
  paddingRight: theme.spacing["2"],
  paddingBottom: theme.spacing["2"],
}));

const DescriptionText = styled(MDSText)(({ theme }) => ({
  color: theme.colors.text.secondary,
}));

const EmailHighlight = styled.span(({ theme }) => ({
  fontWeight: theme.fontWeights.semiBold,
  color: theme.colors.text.primary,
}));
